import { LoadableLazy } from '@confluence/loadable';

export const IntegrationLinkSpotlightLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-IntegrationLinkSpotlight" */ '../src/IntegrationLinkSpotlight.tsx'
			)
		).IntegrationLinkSpotlight,
	loading: () => null,
});
